class LineItem {
  static forPhysicalRecipient (
    physicalCartItem,
    physicalRecipient,
    digitalRecipient,
    emailTemplateIdentifier
  ) {
    return new LineItem(
      physicalCartItem.utid,
      physicalCartItem.selectedAmount,
      physicalRecipient.firstName,
      physicalRecipient.lastName,
      digitalRecipient.email,
      emailTemplateIdentifier,
      physicalRecipient,
      physicalCartItem.fulfillmentType,
      physicalCartItem.name,
      physicalCartItem.fee
    )
  }

  static forDigitalRecipient (
    digitalCartItem,
    digitalRecipient,
    emailTemplateIdentifier
  ) {
    return new LineItem(
      digitalCartItem.utid,
      digitalCartItem.selectedAmount,
      digitalRecipient.firstName,
      digitalRecipient.lastName,
      digitalRecipient.email,
      emailTemplateIdentifier,
      null,
      digitalCartItem.fulfillmentType,
      digitalCartItem.name,
      digitalCartItem.fee
    )
  }

  constructor (
    utid,
    amount,
    firstName,
    lastName,
    email,
    etid,
    address,
    fulfillmentType,
    rewardName,
    fee
  ) {
    this.utid = utid
    this.amount = amount
    this.rewardName = rewardName
    this.fee = fee
    this.recipient = {
      email,
      firstName,
      lastName,
      address
    }
    if (etid) {
      this.etid = etid
    }
    if (fulfillmentType) {
      this.fulfillmentType = fulfillmentType
    }
    this.supplierFields = null
  }
}

export default LineItem
